import React from 'react'
import CounselingContext from '../context/CounselingContext'
import { get } from 'aws-amplify/api'
import { useAuth0 } from '@auth0/auth0-react'

const CounselingProvider = ({ children }) => {
  const { getIdTokenClaims } = useAuth0()
  const baseUrl = process.env.REACT_APP_API_BASE_URL

  const getCounseling = async () => {
    try {
      const idToken = await getIdTokenClaims()

      const resp = get({
        apiName: baseUrl,
        path: '/api/v2/counseling',
        options: {
          headers: {
            'content-type': 'application/json',
            Authorization: `Bearer ${idToken.__raw}`
          }
        }
      })
      const { body } = await resp.response
      const data = await body.json()
      return data.data
    } catch (error) {
      throw new Error(error)
    }
  }

  return (
    <CounselingContext.Provider value={{ getCounseling }}>
      {children}
    </CounselingContext.Provider>
  )
}

export default CounselingProvider
